import { render, staticRenderFns } from "./ErrorCallback.vue?vue&type=template&id=2ddb723a&scoped=true&"
import script from "./ErrorCallback.vue?vue&type=script&lang=js&"
export * from "./ErrorCallback.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2ddb723a",
  null
  
)

export default component.exports